<template>
  <div
    class="dm-header"
    :class="{
      header_hidden: isShowHidden,
      header_visible: !isShowHidden,
    }"
  >
    <router-link to="/" class="logo">
      <img src="@/assets/imgs/common/logo.png" class="logo" alt="" />
    </router-link>

    <img
      src="@/assets/imgs/mobile/header-menu.webp"
      class="menu"
      @click="handleMenu"
      alt=""
    />

    <!-- 菜单弹出层 -->
    <transition name="fade-slide">
      <div class="menu-popup" v-show="isMenuVisible">
        <div class="menu-items">
          <router-link
            :to="item.path"
            class="menu-item"
            :class="{ 'active': isCurrentRoute(item.path) }"
            v-for="item in routesList"
            :key="item.name"
          >
            <div @click="closeMenu">{{ item.name }}</div>
          </router-link>
          <a
            v-for="item in externalLinks"
            :key="item.url"
            :href="item.url"
            target="_blank"
            class="navbarMenuItem"
            @click="closeMenu"
          >
            {{ item.name }}
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},

  data() {
    return {
      isShowHidden: false, // 是否隐藏导航栏
      lastScrollY: 0, // 记录上次滚动位置
      isMenuVisible: false,
      routesList: [
        { path: "/about", name: "首页" },
        { path: "/growthCare", name: "成长关怀" },
        { path: "/companyCulture", name: "我们的文化" },
        // { path: '/jobVacancy', name: '招聘职位' },
      ],
      externalLinks: [
        {
          url: "https://www.zhipin.com/gongsi/job/3402ab67194d2e271nB42Ny5GQ~~.html?ka=company-jobs",
          name: "招聘职位",
        },
      ],
    };
  },

  computed: {},
  watch: {},

  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    closeMenu() {
      this.isMenuVisible = false;
    },
    // 判断是否为当前路由
    isCurrentRoute(path) {
      return this.$route.path === path;
    },
    handleScroll() {
      // 当用户滑动屏幕时，隐藏菜单
      if (this.isMenuVisible) {
        this.isMenuVisible = false;
      }
      const currentScrollY = window.scrollY;
      // 向下滚动且滚动距离大于100px时隐藏
      if (currentScrollY > this.lastScrollY && currentScrollY > 100) {
        this.isShowHidden = true;
      }
      // 向上滚动时显示
      else if (currentScrollY < this.lastScrollY) {
        this.isShowHidden = false;
      }
      this.lastScrollY = currentScrollY;
    },
  },
};
</script>

<style scoped lang="scss" src="@/assets/styles/mobile/header.scss"></style>
